module.exports = __webpack_public_path__ + "static/media/cam-02.3e3171ab.webp";